module.exports = __webpack_public_path__ + "static/media/icone.d91ec8e6.ico";